import { useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface TimeProps {
  time: Date;
  isDateWithTime?: boolean;
}

const Time: FC<TimeProps> = ({ time, isDateWithTime }: TimeProps) => {
  const { t } = useTranslation('Time');
  const language: string = useScopedSelector('/language.locale');
  const now = new Date(Date.now());
  let content: string;
  const local = language === 'fr' ? 'fr-CA' : 'en-CA';

  if (isDateWithTime) {
    content = Intl.DateTimeFormat(local, { dateStyle: 'long', timeStyle: 'short' }).format(time);
  } else {
    const dayDiff = dayOfYear(now) - dayOfYear(time);
    if (dayDiff === 0) {
      content = t('time.today');
    } else if (dayDiff === 1) {
      content = t('time.yesterday');
    } else if (dayDiff <= 7 && dayDiff > 0) {
      content = time.toLocaleDateString(local, { weekday: 'long' });
    } else if (now.getFullYear() === time.getFullYear()) {
      content = time.toLocaleDateString(local, { month: 'long', day: 'numeric' });
    } else {
      content = time.toLocaleDateString(local, { dateStyle: 'long' });
    }
  }

  return <>{content}</>;
};

const dayOfYear = (date: Date): number => ((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) / 24 / 60 / 60 / 1000);

Time.displayName = 'Time';

export default Time;
